import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './SiteFooter';

export default function AuthLayout({ title, description, children }) {
  return <div className="korean-site korean-auth"><Navigation />
    <main id="main-content" className="korean-auth-layout korean-container">
      <aside className="korean-auth-story">
        <p className="korean-eyebrow">VOTRE ESPACE BY ALI</p>
        <h2>Un instant<br /><em>pour vous.</em></h2>
        <p>Vos rendez-vous, vos soins et vos petites attentions réunis au même endroit.</p>
        <div className="korean-auth-photo"><img src="/images/korean-regard-02.jpeg" alt="Un regard sublimé par Ali" /><span>Le naturel, sublimé.</span></div>
      </aside>
      <section className="korean-auth-panel" aria-labelledby="auth-title">
        <Link to="/" className="korean-auth-back">← Retour à l’accueil</Link>
        <p className="korean-eyebrow">KOREAN LASH LIFT BY ALI</p>
        <h1 id="auth-title">{title}</h1>
        <p className="korean-auth-description">{description}</p>
        {children}
      </section>
    </main><Footer /></div>;
}
